import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

import LoginPage       from './pages/LoginPage';
import QuotesPage      from './pages/QuotesPage';
import QuoteDetailPage from './pages/QuoteDetailPage';
import CustomersPage   from './pages/CustomersPage';
import DashboardPage   from './pages/DashboardPage';
import AdminUsersPage  from './pages/AdminUsersPage';
import CatalogPage     from './pages/CatalogPage';
import OdooPage       from './pages/OdooPage';
import ExecutivePage from './pages/ExecutivePage';
import CommissionsPage from './pages/CommissionsPage';
import CommissionRunsPage from './pages/CommissionRunsPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

function PrivateRoute({ children, requireManager, requireAdmin }) {
  const { user, loading, isManager, isAdmin } = useAuth();
  if (loading) return <div className="loading-center" style={{ minHeight:'100vh' }}><div className="spinner" /></div>;
  if (!user)          return <Navigate to="/login" replace />;
  if (requireAdmin   && !isAdmin)   return <Navigate to="/quotes" replace />;
  if (requireManager && !isManager) return <Navigate to="/quotes" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  // Puerta de contrasena temporal. Mientras la bandera este puesta, la unica
  // ruta que existe es /cambiar-password y todo lo demas redirige ahi. El
  // backend ya bloquea la API por su lado; esto evita que la persona se
  // encuentre pantallas vacias llenas de errores 403 sin entender por que.
  if (user && user.must_change_password) {
    return (
      <Routes>
        <Route path="/cambiar-password" element={<ChangePasswordPage />} />
        <Route path="*" element={<Navigate to="/cambiar-password" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/quotes" replace /> : <LoginPage />} />
      <Route path="/dashboard" element={<PrivateRoute requireManager><DashboardPage /></PrivateRoute>} />
      <Route path="/executive" element={<PrivateRoute requireManager><ExecutivePage /></PrivateRoute>} />
      <Route path="/commissions" element={<PrivateRoute requireManager><CommissionsPage /></PrivateRoute>} />
      <Route path="/commissions/runs" element={<PrivateRoute requireManager><CommissionRunsPage /></PrivateRoute>} />
      <Route path="/quotes"    element={<PrivateRoute><QuotesPage /></PrivateRoute>} />
      <Route path="/quotes/:id" element={<PrivateRoute><QuoteDetailPage /></PrivateRoute>} />
      <Route path="/customers" element={<PrivateRoute><CustomersPage /></PrivateRoute>} />
      <Route path="/catalog"   element={<PrivateRoute requireManager><CatalogPage /></PrivateRoute>} />
      <Route path="/admin/users" element={<PrivateRoute requireAdmin><AdminUsersPage /></PrivateRoute>} />
      <Route path="/admin/odoo" element={<PrivateRoute requireAdmin><OdooPage /></PrivateRoute>} />
      <Route path="/cambiar-password" element={<PrivateRoute><ChangePasswordPage /></PrivateRoute>} />
      <Route path="/"  element={<Navigate to="/quotes" replace />} />
      <Route path="*"  element={<Navigate to="/quotes" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{
          style: { background:'var(--bg-2)', color:'var(--text)', border:'1px solid var(--border)', fontSize:13 },
          success: { iconTheme:{ primary:'var(--green)', secondary:'var(--bg-2)' } },
          error:   { iconTheme:{ primary:'var(--red)',   secondary:'var(--bg-2)' } },
        }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
